import React from "react";

const PriceDisplayResellerView: React.FC<PriceDisplayViewProps> = ({
  compound,
  currency,
  customizationPrice,
  previousResellerPrice,
  basePricePVPInput,
  customizationPricePVPInput,
  handleManualEdit,
  handleAutomaticEdit,
  handleBasePriceChange,
  handleCustomizationPriceChange,
  hasCustomization,
  allowEditPrices,
  showCostPrice,
}: PriceDisplayViewProps) => {
  const promoPrice = compound.price.promotional_pvp_with_vat;

  return (
    <>
      {promoPrice != null && promoPrice > 0 && (
        <div className="bg-green-100 border border-green-300 rounded-lg px-3 py-2 mb-2">
          <span className="text-sm font-medium text-green-800">
            🏷️ Preço Promocional:{" "}
            <span className="font-bold">
              {promoPrice.toLocaleString("pt-PT", {
                style: "currency",
                currency: currency,
              })}
            </span>
          </span>
          <span className="text-xs text-gray-500 ml-2 line-through">
            (
            {compound.price.value.toLocaleString("pt-PT", {
              style: "currency",
              currency: currency,
            })}
            )
          </span>
        </div>
      )}
      <div className="text-red-400 is-display-block font-extrabold w-[450px]">
        <span className="">Configuração base:</span>
        <div className="flex is-inline-flex float-end">
          <input
            id="base-price-input"
            type="number"
            style={{ width: "120px" }}
            className="text-right px-2 cursor-text hover:text-red-600 focus:text-red-600 focus:outline-none"
            step={0.01}
            min={compound.price.resell ?? 0}
            onFocus={handleManualEdit}
            onBlur={handleAutomaticEdit}
            value={basePricePVPInput}
            onChange={handleBasePriceChange}
            readOnly={!allowEditPrices}
          />
          <span style={{ marginLeft: 4 }}>
            {compound.price.currency || currency}
          </span>
        </div>
      </div>
      {hasCustomization() && (
        <div className="text-red-400 is-display-block font-extrabold w-[450px]">
          <span className=""> Valor com os opcionais:</span>
          <div className="flex is-inline-flex float-end">
            <input
              id="customization-price-input"
              type="number"
              style={{ width: "120px" }}
              className="text-right px-2 cursor-text hover:text-red-600 focus:text-red-600 focus:outline-none"
              step={0.01}
              onFocus={handleManualEdit}
              onBlur={handleAutomaticEdit}
              value={customizationPricePVPInput}
              onChange={handleCustomizationPriceChange}
              readOnly={!allowEditPrices}
            />
            <span style={{ marginLeft: 4 }}>
              {compound.price.currency || currency}
            </span>
          </div>
        </div>
      )}
      {showCostPrice && customizationPrice && (
        <p className="text-sm font-bold text-gray-400 reseller-cost not-printable">
          Custo:{" "}
          {customizationPrice.toLocaleString("pt-PT", {
            // Use finalPrice here
            style: "currency",
            currency: currency,
          })}{" "}
          (sem IVA)
          {previousResellerPrice != null &&
            previousResellerPrice > customizationPrice && (
              <del className="ml-2 text-xs" title="Preço anterior">
                {previousResellerPrice.toLocaleString("pt-PT", {
                  style: "currency",
                  currency: currency,
                })}
              </del>
            )}
        </p>
      )}
    </>
  );
};

export default PriceDisplayResellerView;
